import React from "react";
import { Tooltip as AntdTooltip } from "antd";

import cx from "classnames";

import "./index.scss";

export const Tooltip = ({ children, overlayClassName, ...props }) => {
  return (
    <AntdTooltip
      overlayClassName={cx("design-system-tooltip", overlayClassName)}
      destroyTooltipOnHide={{ keepParent: false }}
      {...props}
    >
      {children}
    </AntdTooltip>
  );
};
